import React, { createContext, useState, useContext, ReactNode, useEffect } from 'react';
import { useTableHook } from '../Hooks/TableHook';
import { storeIsOpenByOrderType } from '../Utils/Helpers';
import { ORDER_TYPE_NAME_BY_ID } from '../Utils/Constants/Order';

interface StoreType {
  loadingStore: any;
  setLoadingStore: (value: any) => void;
  currentStore: any;
  setCurrentStore: (value: any) => void;
  tables: any;
  setTables: (value: any) => void;
  loadingTables: boolean;
  setLoadingTables: (value: boolean) => void;
  table: any;
  setTable: (value: string | null) => void;
  showTableChoice: boolean;
  setShowTableChoice: (value: boolean) => void;
  checkStoreOpen: CallableFunction;
  cashier: any;
  setCashier: (value: any) => void;
  loadStoreInfoOnCloseMainLoading: boolean;
  setLoadStoreInfoOnCloseMainLoading: (value: boolean) => void;
  requiredTable: boolean;
  setRequiredTable: (value: boolean) => void;

  nextCurrentAddress: any;
  setNextCurrentAddress: (value: any) => void;
  currentAddress: any;
  setCurrentAddress: (value: any) => void;
}

const StoreContext = createContext<StoreType | undefined>(undefined);

export const StoreProvider = ({ children }: { children: ReactNode }) => {

  const [currentStore, setCurrentStore] = useState(() => {
    const storedCurrentStore = localStorage.getItem('current_store')
    return storedCurrentStore ? JSON.parse(storedCurrentStore) : null
  })

  const [cashier, setCashier] = useState(() => {
    const storedCashier = localStorage.getItem('cashier')
    return storedCashier ? JSON.parse(storedCashier) : null
  })

  const [tables, setTables] = useState(() => {
    const storedTables = localStorage.getItem('tables')
    return storedTables ? JSON.parse(storedTables) : null
  })

  const [showTableChoice, setShowTableChoice] = useState(false)
  const [loadingStore, setLoadingStore] = useState(false)

  const [table, setTable] = useState(() => {
    const storedTable = localStorage.getItem('table')
    return storedTable ? storedTable : null
  });

  const [loadStoreInfoOnCloseMainLoading, setLoadStoreInfoOnCloseMainLoading] = useState(false);
  const [requiredTable, setRequiredTable] = useState(false);
  const [nextCurrentAddress, setNextCurrentAddress] = useState<any>(null);

  const [currentAddress, setCurrentAddress] = useState(() => {
    const storedCurrentAddress = localStorage.getItem('current_address')
    return storedCurrentAddress ? JSON.parse(storedCurrentAddress) : null
  })
  const [loadingTables, setLoadingTables] = useState(false);

  const { updateTable } = useTableHook();
  useEffect(() => {
    if (table) {
      updateTable(table);
    } else {
      localStorage.removeItem('table');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [table]);

  useEffect(() => {
    if (currentStore) {
      localStorage.setItem('current_store', JSON.stringify(currentStore));
    } else {
      localStorage.removeItem('current_store');
    }
  }, [currentStore]);

  useEffect(() => {
    if (cashier) {
      localStorage.setItem('cashier', JSON.stringify(cashier));
    } else {
      localStorage.removeItem('cashier');
    }
  }, [cashier]);

  useEffect(() => {
    if (tables) {
      localStorage.setItem('tables', JSON.stringify(tables));
    } else {
      localStorage.removeItem('tables');
    }
  }, [tables]);

  useEffect(() => {
    if (currentAddress) {
      localStorage.setItem('current_address', JSON.stringify(currentAddress));
    } else {
      localStorage.removeItem('current_address');
    }
  }, [currentAddress]);

  const checkStoreOpen = (order_type: number, store:any = currentStore) => {

    const currentWeekday = new Date().getDay();

    if (store.closed || !storeIsOpenByOrderType(ORDER_TYPE_NAME_BY_ID[order_type], store)) {
      return false;
    }

    const services = store.store_workdays.filter((cw: any) =>
      cw.service_type === order_type &&
      cw.active &&
      cw.weekday === currentWeekday
    );

    function isCurrentTimeInRange(service: any) {
      const now = new Date();
      const currentTime = now.toTimeString().split(' ')[0];
      const { operation_from, operation_to } = service;

      return currentTime >= operation_from && currentTime <= operation_to;
    }

    return services.some(isCurrentTimeInRange);
  };


  return (
    <StoreContext.Provider value={{
        currentStore, setCurrentStore,
        tables, setTables,
        loadingTables, setLoadingTables,
        cashier, setCashier,
        loadingStore, setLoadingStore,
        table, setTable,
        showTableChoice, setShowTableChoice,
        checkStoreOpen,
        loadStoreInfoOnCloseMainLoading, setLoadStoreInfoOnCloseMainLoading,
        requiredTable, setRequiredTable,
        nextCurrentAddress, setNextCurrentAddress,
        currentAddress, setCurrentAddress
        }}>
      {children}
    </StoreContext.Provider>
  );
};

export const useStoreContext = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
